import React, { useState, useMemo } from 'react';
import Reveal from '../components/Reveal';
import { schools } from '../data/siteData';

const FindSchool = () => {
  const [city, setCity] = useState('All');
  const cities = ['All', ...Array.from(new Set(schools.map(s => s.city)))];
  const filtered = useMemo(
    () => city === 'All' ? schools : schools.filter(s => s.city === city),
    [city]
  );

  return (
    <div>
      <section style={{ paddingTop: 130, paddingBottom: 70, background: 'linear-gradient(135deg,var(--navy),var(--navy-dark))', textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'var(--fh)', fontSize: '2.6rem', color: '#fff' }}><span style={{ color: 'var(--gold)' }}>Find</span> a School</h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 500, margin: '12px auto 0', lineHeight: 1.8 }}>A Finland Early Years campus, close to you.</p>
      </section>

      <section style={{ padding: '90px 24px' }}>
        <div className="container">
          <Reveal><div className="gold-bar" /><h2 className="sec-heading">Our Campuses</h2><p className="sec-sub">Browse by city to find a campus near you.</p></Reveal>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center', marginBottom: 44 }}>
            {cities.map(c => (
              <button key={c} onClick={() => setCity(c)} style={{
                padding: '9px 20px', borderRadius: 999, border: c === city ? '2px solid var(--gold)' : '1.5px solid #ddd',
                background: c === city ? 'var(--gold)' : '#fff', color: c === city ? 'var(--navy)' : 'var(--body)',
                fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer', transition: 'all 0.25s',
              }}>{c}</button>
            ))}
          </div>

          <div id="school-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 28 }}>
            {filtered.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.05} direction="scale">
                <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
                  <div style={{ height: 170, overflow: 'hidden' }}>
                    <img src={s.image} alt={s.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div style={{ padding: '22px 24px' }}>
                    <div style={{ display: 'inline-block', background: 'var(--light-blue)', color: 'var(--navy)', fontSize: '0.7rem', fontWeight: 700, padding: '3px 10px', borderRadius: 999, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.city}</div>
                    <h3 style={{ fontFamily: 'var(--fh)', color: 'var(--navy)', fontSize: '1.1rem', marginBottom: 8 }}>{s.name}</h3>
                    <p style={{ color: 'var(--body)', fontSize: '0.86rem', lineHeight: 1.7, marginBottom: 14 }}>{s.address}</p>
                    <div style={{ fontSize: '0.82rem', color: 'var(--body)', marginBottom: 4 }}>📞 {s.phone}</div>
                    <div style={{ fontSize: '0.82rem', color: 'var(--body)' }}>✉️ {s.email}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {filtered.length === 0 && (
            <p style={{ textAlign: 'center', color: 'var(--body)', marginTop: 40 }}>No campuses found in this city yet.</p>
          )}
        </div>
        <style>{`
          @media (max-width: 900px) { #school-grid { grid-template-columns: repeat(2,1fr) !important; } }
          @media (max-width: 560px) { #school-grid { grid-template-columns: 1fr !important; } }
        `}</style>
      </section>
    </div>
  );
};

export default FindSchool;
